<template>
<panel>
  <p slot="header">
    Grupy
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click="$router.push({name: 'admin.email-groups.create'})" >Dodaj grupę</ui-button>
  </p>
  <email-groups-list></email-groups-list>


</panel>

</template>
<script>
import EmailGroups from '../../services/EmailGroups'
import EventEmitter from '../../services/EventEmitter'

export default {
  data () {
    return {
      modal: {
        show: false,
        title: 'Dodaj grupę',
        baseCreateTitle: 'Dodaj grupę',
        baseUpdateTitle: 'Edytuj grupę'
      },
      item: EmailGroups.getBaseItem()
    }
  },
  methods: {
    onEmailGroupsChange (e) {
      this.modal.show = false
      EventEmitter.$emit('email-groups.reload', e)
    }
  }
}

</script>


// WEBPACK FOOTER //
// Dashboard.vue?08108f3f